import corePasswordToggle from "coremh/components/passwordToggle";

export default function () {
    corePasswordToggle();
    $(".password-toggler").on("click", function() {
        const $this = $(this);
        const $input = $this.siblings(".form-control");
        if ($input.length) {
            $input.addClass("setCaseInitial");
        }
    });
}
